export const fmtARS = (n) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n);

export const STATUS_LABEL = {
  pending_payment: "Pendiente de pago",
  pending_review: "Por verificar",
  paid: "Pagado",
  processing: "Procesando",
  completed: "Completado",
  failed: "Fallido",
};

export const STATUS_DOT = {
  pending_payment: "bg-neutral-400",
  pending_review: "bg-orange-400",
  paid: "bg-amber-400",
  processing: "bg-sky-400",
  completed: "bg-emerald-400",
  failed: "bg-rose-500",
};
